import { nucleusConstants } from '@lifesize/nucleus';
import _get from 'lodash/get';
import { Reducer } from 'redux';
import { MaxInactiveDaysActions } from '../actions/maxInactiveDaysActions';
import MaxInactiveDaysState from '../state/MaxInactiveDaysState';

const maxInactiveDaysReducer: Reducer<MaxInactiveDaysState> =
  (state = new MaxInactiveDaysState(), action) => {
    switch (action.type) {
      case nucleusConstants.GET_MEETING_INACTIVE_DAYS_SUCCESS:
        return state.set('maxInactiveDays', _get(action.payload, 'maxInactiveDays', 0));
      case MaxInactiveDaysActions.START_FETCHING_ITEMS_TO_BE_DELETED:
        return state.set('isBusyFetchingMeetingsToDelete', true);
      case MaxInactiveDaysActions.DONE_FETCHING_ITEMS_TO_BE_DELETED:
        return state.set('isBusyFetchingMeetingsToDelete', false);
      default:
        return state;
    }
  };

export default maxInactiveDaysReducer;
